// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useEffect, useRef } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { CharacterLimitCounter, TextEditor, Dropdown } from 'ui_kit_qmd'
import { ConfirmationPopup } from '../confirmation-popup/confirmationpopup'
import {
  OTHER_DROPDOWN_OPTION,
  unresolvedReasonsDropdownOptions,
  VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_PRIMARY_BTN_TEXT,
  VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_SECONDARY_BTN_TEXT,
  VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_SUBTITLE,
  VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_TITLE,
} from '../../utils/constants'
import './UnresolvedVisitReasonPopUp.scss'

const confirmationPopUpStyle = { marginTop: 125 }

const UnresolvedVisitReasonPopUp = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onClickCancelBtn,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onClickSaveBtn,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    popUpError,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    dropdownValue,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setDropdownValue,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setPopUpText,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    popUpText,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    textBoxValueLengthLimit,
  }) => {
    const textEditorRef = useRef(null)
    useEffect(
      () => () => {
        setDropdownValue('')
        setPopUpText('')
      },
      [setDropdownValue, setPopUpText],
    )

    return (
      // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
      <ConfirmationPopup
        id='unresolved-visit-call-room-reason-pop-up-id'
        title={VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_TITLE}
        msg={VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_SUBTITLE}
        additionalContainerClass='unresolved-visit-call-room-reason-pop-up'
        primaryBtnAction={onClickSaveBtn}
        primaryBtnText={VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_PRIMARY_BTN_TEXT}
        popUpBoxStyle={confirmationPopUpStyle}
        secondaryBtnAction={onClickCancelBtn}
        secondaryBtnText={VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_SECONDARY_BTN_TEXT}
        closeAction={onClickCancelBtn}
        renderBody={
          <div className='unresolvedReasonPopUpTextEditorContainer'>
            <Dropdown
              options={unresolvedReasonsDropdownOptions}
              dropdownMainContainerAdditionalClass='unresolved-reason-pop-up-dropdown'
              value={dropdownValue}
              setValue={setDropdownValue}
              localError={popUpError && dropdownValue !== OTHER_DROPDOWN_OPTION ? popUpError : ''}
              dropId='ReasonDropDown'
              label='Reason*'
            />
            {dropdownValue === OTHER_DROPDOWN_OPTION && (
              <>
                <TextEditor
                  placeHolderText='Type a reason*'
                  id='unresolvedReasonTextEditor'
                  isError={popUpError}
                  ref={textEditorRef}
                  setText={setPopUpText}
                  descriptionLocalError={popUpError}
                />
                <CharacterLimitCounter
                  currentAmount={popUpText?.length}
                  limit={textBoxValueLengthLimit}
                  isHighlightError={popUpText?.length > textBoxValueLengthLimit}
                />
              </>
            )}
          </div>
        }
      />
    )
  },
)

export default UnresolvedVisitReasonPopUp
